import React from 'react';
import { faClock } from '@fortawesome/free-solid-svg-icons';
import StatusAlertCard from './StatusAlertCard';

function PendingIssuanceAlert() {
  return (
    <StatusAlertCard tone="success" icon={faClock} title="In Attesa Emissione">
      <p>
        Quando l'agente di backoffice carica la polizza,
        riceverai una notifica e il contratto potrà essere
        scaricato.
      </p>
    </StatusAlertCard>
  );
}

export default PendingIssuanceAlert;
